// فرم‌ساز سه‌ستونی (SCR-STAFF-615) برای استودیو فرم.
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@phoenix/i18n';
import { FormRunner, ListPage, type FormRunnerQuestion, type FormRunnerWidth } from '@phoenix/ui';
import { useState } from 'react';

const types = ['short_text', 'likert', 'yes_no', 'number', 'info', 'calculated'] as const;

export function FormStudioPage() {
  const { t } = useTranslation('doc');
  const [questions, setQuestions] = useState<FormRunnerQuestion[]>([]);
  const [selected, setSelected] = useState(0);
  const [width, setWidth] = useState<FormRunnerWidth>('desktop');
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const current = questions[selected];

  return (
    <ListPage screenId="SCR-STAFF-615" titleKey="doc:studio.title">
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
        <Stack spacing={1} sx={{ width: { md: 220 } }}>
          <Typography variant="subtitle2">{t('doc:studio.types')}</Typography>
          {types.map((type) => (
            <Button
              key={type}
              variant="outlined"
              onClick={() =>
                setQuestions((items) => [
                  ...items,
                  {
                    code: `q${items.length + 1}`,
                    type,
                    label: t(`doc:studio.type.${type}`),
                    required: type !== 'info' && type !== 'calculated',
                  },
                ])
              }
            >
              {t(`doc:studio.type.${type}`)}
            </Button>
          ))}
        </Stack>
        <Stack spacing={1} sx={{ flex: 1 }}>
          <Typography variant="subtitle2">{t('doc:studio.canvas')}</Typography>
          {questions.map((question, index) => (
            <Button key={question.code} variant={index === selected ? 'contained' : 'text'} onClick={() => setSelected(index)}>
              {question.label}
            </Button>
          ))}
          <ToggleButtonGroup
            exclusive
            value={width}
            onChange={(_, value: FormRunnerWidth | null) => value && setWidth(value)}
            size="small"
          >
            <ToggleButton value="mobile">{t('doc:studio.width.mobile')}</ToggleButton>
            <ToggleButton value="tablet">{t('doc:studio.width.tablet')}</ToggleButton>
            <ToggleButton value="desktop">{t('doc:studio.width.desktop')}</ToggleButton>
          </ToggleButtonGroup>
          <FormRunner
            questions={questions}
            answers={answers}
            width={width}
            requiredMark={t('doc:studio.required_mark')}
            optionalMark={t('doc:studio.optional_mark')}
            nextLabel={t('doc:studio.next')}
            backLabel={t('doc:studio.back')}
            onChange={(code, value) => setAnswers((currentAnswers) => ({ ...currentAnswers, [code]: value }))}
          />
        </Stack>
        <Stack spacing={1} sx={{ width: { md: 260 } }}>
          <Typography variant="subtitle2">{t('doc:studio.properties')}</Typography>
          {current ? (
            <TextField
              select
              label={t('doc:studio.required')}
              value={current.required ? 'yes' : 'no'}
              onChange={(event) =>
                setQuestions((items) =>
                  items.map((item, index) => (index === selected ? { ...item, required: event.target.value === 'yes' } : item)),
                )
              }
            >
              <MenuItem value="yes">{t('doc:studio.required_yes')}</MenuItem>
              <MenuItem value="no">{t('doc:studio.required_no')}</MenuItem>
            </TextField>
          ) : null}
        </Stack>
      </Stack>
    </ListPage>
  );
}

/** صفحه عمومی فرم (SCR-PUBLIC-015). شروع بعد از OTP در API. */
export function PublicStudioFormPage() {
  const { t } = useTranslation('doc');
  return (
    <ListPage screenId="SCR-PUBLIC-015" titleKey="doc:studio.public_title">
      <Typography>{t('doc:studio.public_hint')}</Typography>
    </ListPage>
  );
}
